import { i18n } from '@lt/localization';
import React from 'react';

import MultichoiceFilterGroup from '../../../../../../../components/Filters/components/MultichoiceFilterGroup';
import type { ExtendedFilterInfo, CommonFilterProps } from '../types';

const FilterFlightType = (props: CommonFilterProps) => (
  <MultichoiceFilterGroup {...props} Filter={FilterFlightType} />
);

const filterNames = {
  charter: i18n.t('checkout.filter.flightType.charter'),
  regular: i18n.t('checkout.filter.flightType.regular'),
  block: i18n.t('checkout.filter.flightType.block'),
  'n/a': i18n.t('checkout.filter.flightType.unknown'),
};

FilterFlightType.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) => filterOptionData.id && filterNames[filterOptionData.id];

// TODO: Раскомментить, когда появятся тексты
// FilterFlightType.getFilterDescription = (data: ExtendedFilterInfo) =>
//   data.id === 'block' ? 'Тултип!' : undefined;

FilterFlightType.filterName = 'flight_types';
FilterFlightType.filterLabel = i18n.t('checkout.filter.flightType.label');

export default FilterFlightType;
